import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  createCategoryModal: {
    width: "80vw !important",
    maxWidth: 500,
  },
}));
